import { render, staticRenderFns } from "./Handling.vue?vue&type=template&id=b944d9b4"
import script from "./Handling.vue?vue&type=script&lang=js"
export * from "./Handling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports